export const EPublicApprovalScreenParams = {
    APPROVING: 'approving',
    TOKEN: 'token',
}
